import { FC } from 'react';

import IconButton from 'components/_core/IconButton';
import SunshineDropdown from 'components/_core/SunshineDropdown';

import locales from './locales';

interface ActionsMenuProps {
  isLoading?: boolean;
  onDeleteLogo: () => void;
  onReplaceLogo: () => void;
}

const ActionsMenu: FC<ActionsMenuProps> = ({
  isLoading,
  onDeleteLogo,
  onReplaceLogo,
}) => (
  <SunshineDropdown>
    <SunshineDropdown.Trigger>
      <IconButton
        aria-label=""
        icon="vertical-ellipsis"
        isLoading={isLoading}
        variant="secondary"
      />
    </SunshineDropdown.Trigger>

    <SunshineDropdown.List>
      <SunshineDropdown.Item icon="switch" onClick={onReplaceLogo}>
        {locales.replaceLogo}
      </SunshineDropdown.Item>

      <SunshineDropdown.Item
        colorScheme="red"
        icon="trash"
        onClick={onDeleteLogo}
      >
        {locales.deleteLogo}
      </SunshineDropdown.Item>
    </SunshineDropdown.List>
  </SunshineDropdown>
);

export default ActionsMenu;
